<template>
    <v-list-item @click.stop.prevent="$evt => sendMessage($evt, item)">
      <v-list-item-icon>
        <v-icon>icon-ayudadigital-appmovil</v-icon>
      </v-list-item-icon>

      <v-list-item-content v-text="$t('components.share.pushSMS.action')" />
    </v-list-item>
  </template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async sendMessage(evt, item) {
      evt.preventDefault();
      try {
        const messageId = await this.$store.dispatch(
          'messages/createNotificationMessage',
          {
            icon: 'progress-circular',
            title: this.$t('components.share.pushSMS.create'),
          },
        );
        const { id, userid } = this.$store.getters['session/user'];
        let titulo = '';
        let texto = '';

        if (item.type === 'KI' && !item.tlfno && !item.urlCorta) {
          titulo = this.$t('components.share.pushSMS.TitleKI');
          texto = this.$t('components.share.pushSMS.TextKI', [item.formName]);
        } else if (item.type === 'NEWS') {
          titulo = this.$t('components.share.pushSMS.TitleNews');
          texto = this.$t('components.share.pushSMS.TextNews', [item.formName]);
        } else if (item.type === 'PULSO') {
          titulo = this.$t('components.share.pushSMS.TitlePulso');
          texto = this.$t('components.share.pushSMS.TextPulso', [item.formName]);
        } else {
          titulo = this.$t('components.share.pushSMS.TitleForm');
          texto = this.$t('components.share.pushSMS.TextForm', [item.formName]);
        }
        if (item.tlfno) {
          titulo = 'Teléfono Compartido';
          texto = item.tlfno;
        } else if (item.urlCorta) {
          titulo = 'URL Compartida';
          texto = item.urlCorta;
        }

        const data = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'gestnotif/notificaciones/sms',
          },
          url: item.url,
          tlfno: item.tlfno || null,
          urlCorta: item.urlCorta || null,
          type: 'MOBILE',
          message: {
            dmsasSuscriptores: [userid],
            asunto: titulo,
            texto,
            template: {
              code: item.tlfno ? 'NTF_CLIC_2_PUSH_THEM_030' : 'NOT_WHAFB_ENL_018',
              keys: {
                asunto: `${titulo}`,
                cuerpo: `${texto}`,
              },
            },
            datos: {
              title: `${titulo}`,
              body: `${texto}`,
              priority: 'high',
              header: `${titulo}`,
              type: 'public',
              content: `${texto}`,
            },
            priorizarFirebase: true,
          },
        };

        const result = await this.$api.getClient('gestorNotificacion').shareMobileMessage(data);

        if (result.status === 200) {
          const messageText = `${this.$t('components.share.pushSMS.share')} ${this.phoneNumber()}`;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: messageText,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            title: this.$t('components.share.pushSMS.shareFail'),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
        }
        this.$root.$emit('finishShare');
      } catch (ex) {
        console.error('error sending push/sms message', ex);
        this.$emit('input');
        this.$root.$emit('finishShare');
      }
    },
    phoneNumber() {
      const { mobilePhone } = this.$store.getters['session/user'];
      return `******${mobilePhone.substr(mobilePhone.length - 3, 3)}`;
    },
  },
};
</script>

<style>
.icon-ayudadigital-appmovil:before {
  color: #000000;
}
</style>
